import { z } from "zod";

export const EmailSchema = z.string().email();

export const UrlSchema = z.string().url();

export const TelSchema = z
  .string()
  .regex(/^[+0-9()\-\s]+$/u)
  .refine((value) => {
    const digits = value.replace(/[^0-9]/g, "");
    return digits.length >= 6 && digits.length <= 15;
  }, "Please enter a valid phone number");
